import { 
    columnsUserTable,
    columnsCustomerTable,
    columnsEmployeeTable,
    columnsRolesTable,
    columnsRolePermissionsTable,
    columnsFollowupTable,
    columnsDocumentTable,
    columnsCommunicationTable,
    columnsAuditReportTable,
    columnsPaymentRecoveryTable,
    columnsGSTCaseTable,
    columnsInquiryTable,
} from "./column";

export const userListData = async (data, thisEvt) => {
    if(data.length > 0) {
        let temp = [];
        data?.map((data)=>{
            temp.push([
                data.avatar,
                `${data.firstName ? data.firstName : ""} ${data.lastName ? data.lastName : ""}`,
                data.email,
                data.mobile,
                data._id,
                data.status
            ])
        })
        let options = {
            filter: false,
            search : false,
            responsive: "scroll",
            rowsPerPage: thisEvt.state.rowsPerPage,
            selectableRows : false,
            rowsPerPageOptions: [10,20,50,100],
            serverSide: true,
            count: thisEvt.state.count,
            page : thisEvt.state.page-1,
            downloadOptions: {
                filename: "user-details.csv",
            },
            onTableChange: (action, tableState) => {
                if (action === "changePage" || action === "changeRowsPerPage") {
                    console.log("Go to page", tableState.page+1);
                    thisEvt.changePage(tableState.page+1,tableState.rowsPerPage);
                }
            }
        };
        return { data : temp, columns : columnsUserTable, options : options };
    } else{
        return { data : [], columns : [], options : {}};
    }
}

export const customerListData = async (data, thisEvt) => {
    if(data.length > 0) {
        let temp = [];
        data.map((data)=>{
            temp.push([
                data?._id,
                `${data?.name ? data.name : ""}`,
                // data.username || "-" ,
                data?.email || "-",
                data?.mobile,
                data?.companyName,
                data
            ])
        })
        let options = {
            filter: true,
            search : true,
            responsive: "standard",
            rowsPerPage: thisEvt.state.rowsPerPage,
            selectableRows :false,
            rowsPerPageOptions: [10,20,50,100],
            serverSide: false,
            count: thisEvt.state.count,
            page : thisEvt.state.page-1,
            downloadOptions: {
                filename: "customers-list.csv",
            },
            onTableChange: (action, tableState) => {
                if (action === "changePage" || action === "changeRowsPerPage") {
                    console.log("Go to page", tableState.page+1);
                    thisEvt.changePage(tableState.page+1,tableState.rowsPerPage);
                }
            }
        };
        return { data : temp, columns : columnsCustomerTable(thisEvt), options : options };
    } else{
        return { data : [], columns : [], options : {}};
    }
}

export const employeeListData = async (data, thisEvt) => {
    if(data.length > 0) {
        let temp = [];
        data.map((data)=>{
            temp.push([
                data._id,
                `${data.name ? data.name : ""}`,
                data.email,
                data.mobile,
                data?.userId?.role || "—",
                data
            ])
        })
        let options = {
            filter: true,
            search : true,
            responsive: "standard",
            rowsPerPage: thisEvt.state.rowsPerPage,
            selectableRows :false,
            rowsPerPageOptions: [10,20,50,100],
            serverSide: false,
            count: thisEvt.state.count,
            page : thisEvt.state.page-1,
            downloadOptions: {
                filename: "customers-list.csv",
            },
            onTableChange: (action, tableState) => {
                if (action === "changePage" || action === "changeRowsPerPage") {
                    console.log("Go to page", tableState.page+1);
                    thisEvt.changePage(tableState.page+1,tableState.rowsPerPage);
                }
            }
        };
        return { data : temp, columns : columnsEmployeeTable(thisEvt), options : options };
    } else{
        return { data : [], columns : [], options : {}};
    }
}

export const rolesListData = async (data, thisEvt) => {
    if(data.length > 0) {
        let temp = [];
        data.map((data)=>{
            temp.push([
                data._id,
                `${data.name ? data.name : ""}`,
                data._id
            ])
        })
        let options = {
            filter: false,
            search : false,
            responsive: "standard",
            rowsPerPage: thisEvt.state.rowsPerPage,
            selectableRows : false,
            rowsPerPageOptions: [],
            serverSide: true,
            pagination:false,
            count: thisEvt.state.count,
            page : thisEvt.state.page-1,
            downloadOptions: {
                filename: "customers-list.csv",
            },
            onTableChange: (action, tableState) => {
                if (action === "changePage" || action === "changeRowsPerPage") {
                    console.log("Go to page", tableState.page+1);
                    thisEvt.changePage(tableState.page+1,tableState.rowsPerPage);
                }
            }
        };
        return { data : temp, columns : columnsRolesTable(thisEvt), options : options };
    } else{
        return { data : [], columns : [], options : {}};
    }
}

export const rolesPermissionListData = async (data, thisEvt) => {
    if(data.length > 0) {
        let temp = [];
        data.map((data)=>{
            temp.push([
                data._id,
                `${data.name ? data.name : ""}`,
                data?.roleId?.name,
                data?.permissionId?.operation,
                data?._id
            ])
        })
        let options = {
            filter: false,
            search : false,
            responsive: "standard",
            rowsPerPage: thisEvt.state.rowsPerPage,
            selectableRows : false,
            rowsPerPageOptions: [],
            serverSide: true,
            pagination:false,
            count: thisEvt.state.count,
            page : thisEvt.state.page-1,
            downloadOptions: {
                filename: "role-permission.csv",
            },
            onTableChange: (action, tableState) => {
                if (action === "changePage" || action === "changeRowsPerPage") {
                    console.log("Go to page", tableState.page+1);
                    thisEvt.changePage(tableState.page+1,tableState.rowsPerPage);
                }
            }
        };
        return { data : temp, columns : columnsRolePermissionsTable(thisEvt), options : options };
    } else{
        return { data : [], columns : [], options : {}};
    }
}
export const FollowupListData = async (dataArray, thisEvt) => {
  if (dataArray.length > 0) {
    const temp = dataArray.map((data) => [
      data.title,                                       
      data.date,
      data.time,        
      // data.customer ,                                
      // data.employee ,                                  
      data.note ,                                      
      data.priority,                             
      data.status,                                     
      data,                                      
    ]);

    const options = {
      filter: true,
      search: true,
      responsive: "standard",
      rowsPerPage: 10,
      selectableRows: false,
      rowsPerPageOptions: [10, 20, 50, 100],
      serverSide: false,
      downloadOptions: {
        filename: "followup-list.csv",
      },
    };

    return {
      data: temp,
      columns: columnsFollowupTable(thisEvt),
      options,
    };
  } else {
    return { data: [], columns: [], options: {} };
  }
};

export const DocumentListData = async (dataArray, thisEvt) => {
    if (dataArray.length > 0) {
        const temp = dataArray.map((data) => [
            data,
            data.uploadedBy,
            data.type,
            data.fileType,
            data?.category || "-",
            data.createdAt,
            data
        ]);

        const options = {
            filter: true,
            search: true,
            responsive: "standard",
            rowsPerPage: 10,
            selectableRows: false,
            rowsPerPageOptions: [10, 20, 50, 100],
            serverSide: false,
            downloadOptions: {
                filename: "common-documents.csv",
            },
        };

        return {
            data: temp,
            columns: columnsDocumentTable(thisEvt),
            options,
        };
    } else {
        return { data: [], columns: [], options: {} };
    }
};

export const CommunicationLogListData = async (dataArray, thisEvt) => {
  if (dataArray.length > 0) {
    const temp = dataArray.map((data) => [
      data.date,
      data.time,
      data.type,
      data.channel,
      data.relatedTo,
      data.name,
      data.subject,
      data
    ]);

    const options = {
      filter: true,
      search: true,
      responsive: "standard",
      rowsPerPage: 10,
      selectableRows: false,
      rowsPerPageOptions: [10, 20, 50, 100],
      serverSide: false,
      downloadOptions: {
        filename: "communication-log.csv",
      },
    };

    return {
      data: temp,
      columns: columnsCommunicationTable(thisEvt),
      options,
    };
  } else {
    return { data: [], columns: [], options: {} };
  }
};
export const AuditReportListData = async (dataArray, thisEvt) => {
  if (dataArray.length > 0) {
    const temp = dataArray.map((data) => [
      data.date,
      data.time,
      data.user,
      data.role,
      data.activity,
      data.details,
    ]);

    const options = {
      filter: true,
      search: true,
      responsive: 'standard',
      rowsPerPage: 10,
      selectableRows: false,
      rowsPerPageOptions: [10, 20, 50, 100],
      serverSide: false,
      downloadOptions: {
        filename: 'audit-report.csv',
      },
    };

    return {
      data: temp,
      columns: columnsAuditReportTable(thisEvt),
      options,
    };
  } else {
    return { data: [], columns: [], options: {} };
  }
};
export const InquiryListData = async (dataArray, thisEvt) => {
  if (dataArray.length > 0) {
    const temp = dataArray.map((data) => [
      data.name,
      data.service,
      data.priority,
      data.status,
      data.assignedTo,
      data.nextFollowup,

      data.type,
      data.channel,
      data.relatedTo,
      data.subject,

      data, // followup button
      data, // action
    ]);

    const options = {
      filter: true,
      search: true,
      responsive: "standard",
      rowsPerPage: 10,
      selectableRows: false,
      rowsPerPageOptions: [10, 20, 50, 100],
      serverSide: false,
    };

    return {
      data: temp,
      columns: columnsInquiryTable(thisEvt),
      options,
    };
  } else {
    return { data: [], columns: [], options: {} };
  }
};
export const GSTCaseListData = async (dataArray, thisEvt) => {
  if (dataArray.length > 0) {
    const temp = dataArray.map((data) => [
      data.caseId,
      data.customerId?.companyName,
      data.GSTIN,
      data.subject,
      data.amount,
      data.stage,
      data.status,
      data,
    ]);

    const options = {
      filter: true,
      search: true,
      responsive: "standard",
      rowsPerPage: 10,
      selectableRows: false,
      rowsPerPageOptions: [10, 20, 50, 100],
      serverSide: false,
      downloadOptions: {
        filename: "gst-litigation-cases.csv",
      },
    };

    return {
      data: temp,
      columns: columnsGSTCaseTable(thisEvt),
      options,
    };
  } else {
    return { data: [], columns: [], options: {} };
  }
};
export const PaymentRecoveryListData = async (dataArray, thisEvt) => {
  if (dataArray.length > 0) {
    const temp = dataArray.map((data) => [
      data.diaryNo,
      data.applicantName,
      data.buyerName,
      data.amount,
      data.caseNo,
      data.status,
      data.stage,
      data.legalNoticeDate,
      data,
    ]);

    const options = {
      filter: true,
      search: true,
      responsive: "standard",
      rowsPerPage: 10,
      selectableRows: false,
      rowsPerPageOptions: [10, 20, 50, 100],
      download: true,
      print: true,
      downloadOptions: {
        filename: "payment-recovery.csv",
      },
    };

    return {
      data: temp,
      columns: columnsPaymentRecoveryTable(thisEvt),
      options,
    };
  } else {
    return { data: [], columns: [], options: {} };
  }
};
